import { createRouter, createWebHistory } from 'vue-router'
import CanvasPage from '@/pages/CanvasPage.vue'
import ProcessPage from '@/pages/ProcessPage.vue'

const routes = [
  {
    path: '/',
    name: 'welcome',
    component: CanvasPage
  },
  {
    path: '/process',
    name: 'process',
    component: ProcessPage
  },
  {
    path: '/canvas',
    name: 'canvas',
    component: CanvasPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
